module.exports = __webpack_public_path__ + "static/media/Sharp-LQ121S1LG88-Mechanical-Drawing.7dba0df9.gif";